import { Flex, HStack, Text } from '@chakra-ui/react';
import { CarouselButton, useCarousel } from '@time-line/components/common';

import type { ProductSeeItInActionProps } from '.';

export const ProductSeeItInActionTitle = ({
  title,
}: Pick<ProductSeeItInActionProps, 'title'>) => {
  const { showControls } = useCarousel();

  return (
    <HStack justify="space-between" my="2xs">
      <Text as="span" size="title2">
        {title}
      </Text>
      {showControls && (
        <Flex gap="3xs">
          <CarouselButton
            direction="prev"
            _disabled={{
              pointerEvents: 'none',
              transitionDuration: 'slow',
              color: 'blackAlpha.500',
            }}
          />
          <CarouselButton
            direction="next"
            _disabled={{
              pointerEvents: 'none',
              transitionDuration: 'slow',
              color: 'blackAlpha.500',
            }}
          />
        </Flex>
      )}
    </HStack>
  );
};
